import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { getAppTitle } from './utils';
import { Loader } from 'semantic-ui-react';

import {
  StyledContainer,
  StyledContentContainer,
  StyledHeading,
  StyledLineBreak,
} from './SplashScreen.styles';

import packageData from '../../../../package.json';
import { ACCESSIBILITY_ROLE, TAB_IDX_DEFAULT } from 'EvidencaVrednotenja/stores/Constants';
const buildDate = process.env.REACT_APP_BUILD_DATE;

class SplashScreen extends Component {
  render() {
    const { withLoader, component } = this.props;

    const appTitle = getAppTitle();

    return (
      <StyledContainer>
        <StyledContentContainer
          tabIndex={TAB_IDX_DEFAULT}
          role={ACCESSIBILITY_ROLE}
          aria-label={`${appTitle !== '' && appTitle}. ${component}. v. ${
            packageData.version
          } (${buildDate})`}
        >
          {appTitle !== '' && <StyledHeading>{appTitle}</StyledHeading>}
          <StyledLineBreak />
          {withLoader && <Loader style={{ margin: '0 auto 20px auto' }} active inverted inline size="big" />}
          {component}
          <StyledLineBreak />
          {`v. ${packageData.version} (${buildDate})`}
        </StyledContentContainer>
      </StyledContainer>
    );
  }
}

SplashScreen.propTypes = {
  component: PropTypes.node.isRequired,
};

export default SplashScreen;
